import * as yup from 'yup'

export const allergySchema = yup.object({
  allergen: yup.string().required('Allergen is required'),
  category: yup.string().required('Category is required'),
  note: yup.string(),
  reaction: yup.string().required('Reaction is required'),
  reaction_type: yup.string().optional(),
  severity: yup.string().required('Severity is required')
  // icd_codings_attributes: yup
  //   .array()
  //   .of(
  //     object().shape({
  //       icd_code_id: yup.string()
  //     })
  //   )
  //   .optional()
})
